import React from 'react';
import { useTranslation } from 'react-i18next';

import './LoadingSpinner.css';

function LoadingSpinner(props) {
  const { t } = useTranslation();

  return (
    <div
      tabIndex={-1}
      role="status"
      aria-label={t('accessibility.loading')}
      className={`${
        props.asOverlay ? 'loading-spinner__overlay' : props.asImage ? 'image-cont' : 'center'
      }`}
    >
      <div className="lds-dual-ring" />
    </div>
  );
}

export default LoadingSpinner;
